import { LoadingState } from "@commerce-os/ui";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect } from "react";

import { useDeploymentQuery } from "../../app/deployment";
import { useT } from "../../app/i18n";
import { SignupForm } from "../../features/auth/signup-form";
import { realSignupUrl } from "../../features/sandbox/links";

export const Route = createFileRoute("/_auth/sign-up")({ component: SignUpPage });

function SignUpPage() {
  const { t } = useT();
  const deployment = useDeploymentQuery();
  if (deployment.data?.signupEnabled === false)
    return <NoSignupHere sandbox={deployment.data.mode === "sandbox"} />;
  return (
    <>
      <h1 className="mb-6 text-xl font-semibold">{t("auth:signUp.title")}</h1>
      <SignupForm />
    </>
  );
}

/**
 * A sandbox or a dedicated instance opens no businesses (the API 404s signup). The sandbox sends the visitor on to the
 * real signup (SB-05, with this address's `?lang&plan…`); anywhere else, a note and the way to sign in.
 */
function NoSignupHere({ sandbox }: { sandbox: boolean }) {
  const { t } = useT();
  const target = sandbox ? realSignupUrl() : null;
  useEffect(() => {
    if (target === null) return;
    const url = new URL(target);
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (!url.searchParams.has(key)) url.searchParams.set(key, value);
    });
    window.location.replace(url.toString());
  }, [target]);
  if (target !== null) return <LoadingState label={t("states.loading")} />;
  return (
    <>
      <h1 className="mb-3 text-xl font-semibold">{t("auth:signUp.title")}</h1>
      <p className="mb-6 text-muted-foreground">{t("auth:signUp.unavailable")}</p>
      <Link to="/sign-in" className="font-medium text-primary hover:underline">
        {t("auth:signUp.haveAccount")}
      </Link>
    </>
  );
}
